import cleanedFilename from '~/util/cleanedFilename';

export default {
  SAVE_BAR_SAVE_BUTTON: `${cleanedFilename(__filename)}-save-bar-save-button`,
  SAVE_BAR_CANCEL_BUTTON: `${cleanedFilename(
    __filename,
  )}-save-bar-cancel-button`,
};
